export default "__VITE_PUBLIC_ASSET__e7cb522d__"